<template>
  <div>
    <b-row>
      <b-col sm="12">
        <p>
          <strong>O que é Notificação Penalidade?</strong>
        </p>
        <ul>
          <li class="mb-3">
            A notificação de penalidade indica que está imposta a cobrança da
            multa (se aplicavel), devendo assim ser quitada no prazo
            estabelecido. A partir dessa notificação é garantido o direito à
            interposição de recurso à 1ª (Primeira) Instância - JARI (Junta
            Administrativa Recursos de Infração).
          </li>
        </ul>
      </b-col>
    </b-row>
    <hr />
    <b-row  v-if="auto_infracao_transito.temPenalidade() && !auto_infracao_transito.isCancelado()">
      <b-col cols="4">
        <b-form-group label-size="sm" label-class="text-secondary">
          <template slot="label"
            ><span>Prazo Entrada de Recurso JARI&nbsp;</span
            ><b-icon
              v-b-tooltip.hover
              title="JARI - Junta Administrativa de Recursos de Infrações"
              class="text-dark"
              icon="question-circle-fill"
            ></b-icon
          ></template>
          <span class="font-weight-bold">
            {{
              temValor(dataBrasil(auto_infracao_transito.prazo_recurso_jari))
            }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="4">
        <b-form-group
          label="Pontuação da Multa"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{
              temValor(
                auto_infracao_transito.vigencia_codigo_infracao.pontuacao
              )
            }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group
          label="Valor da Infração *"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{
              temValor(formataReal(valorDaInfracao))
            }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="4"  v-if="auto_infracao_transito.temPenalidade() && !auto_infracao_transito.isCancelado()">
        <b-form-group
          label="Prazo Vencimento - Pagamento Com Desconto"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{
              temValor(dataBrasil(auto_infracao_transito.prazo_recurso_jari))
            }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group
          label="Data Conversão Advertência"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{
              temValor(
                dataHoraBrasil(
                  auto_infracao_transito.data_conversao_advertencia
                )
              )
            }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="4">
        <b-form-group
          label="Tipo Penalidade"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{ temValor(tipoPnenalidade()) }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group
          label="Número Notificação"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{ temValor(notificacao.numero_notificacao) }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group
          label="Data Emissão"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{ temValor(dataBrasil(notificacao.data_emissao)) }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="4">
        <b-form-group
          label-size="sm"
          label-class="text-secondary"
        >
          <template slot="label"
            ><span v-if="possuidor.ind_adesao_veiculo_sne">Data Postagem (Registro SNE)</span
          >
          <span v-else>Data Postagem (Correios)</span
          ></template>
          <span class="font-weight-bold">
            {{ temValor(dataBrasil(notificacao.data_postagem)) }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="4" v-if="!possuidor.ind_adesao_veiculo_sne">
        <b-form-group label-size="sm" label-class="text-secondary">
          <template slot="label"
            ><span>Data Publicação DOM&nbsp;</span
            ><b-icon
              v-b-tooltip.hover
              title="DOM - Diário Oficial do Município de Belo Horizonte"
              class="text-dark"
              icon="question-circle-fill"
            ></b-icon
          ></template>
          <span class="font-weight-bold">
            {{ temValor(dataBrasil(notificacao.data_publicacao_dom)) }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col sm="12">
        <ul>
          <li class="mb-3">
            Para multas emitidas diretamente pela Prefeitura de Belo Horizonte,
            aplica-se desconto de 20% do valor da infração desde que o pagamento
            seja realizado até o "Prazo Vencimento - Pagamento Com Desconto".
            <br />
          </li>
          <li>
            Para multas que possuem Adesão ao SNE - Sistema Notificação
            Eletrônica (Nacional), o pagamento com desconto de 40% só pode ser
            feito através de guias geradas pelo aplicativo. Para orientações:
            <b-link
              target="_blank"
              class="text-primary"
              href="https://www.gov.br/prf/pt-br/assuntos/sistema-de-notificacao-eletronica-sne"
              >acesse aqui</b-link
            >. O SNE está no aplicativo Carteira Digital de Trânsito - CDT,
            <b-link
              target="_blank"
              class="text-primary"
              href="https://www.loja.serpro.gov.br/sne"
              >acesse aqui para instalar</b-link
            >
          </li>
        </ul>
      </b-col>
    </b-row>
    <b-overlay :show="showmanowanderley" rounded="sm">
      <pessoa-ait
        :pessoa="possuidor"
        :tituloPossuidor="'Proprietário do Veículo no momento da emissão da Notificação de Penalidade'"
      />
    </b-overlay>
  </div>
</template>

<script>
import AutoInfracaoTransito from "@/models/AutoInfracaoTransito";
import PessoaAutoInfracaoTransito from "@/models/PessoaAutoInfracaoTransito";
import Notificacao from "@/models/Notificacao";
import { helperDatas, helperNumeros } from "@/helpers";
import PessoaAit from "@/views/consulta_multa/aba/_pessoa";

export default {
  name: "NotificacaoNAP",

  components: {
    PessoaAit,
  },

  props: {
    dadosAit: {
      type: Object,
      default: function () {
        return {};
      },
    },
    auto_infracao_transito: {
      type: Object,
      default: function () {
        return new AutoInfracaoTransito();
      },
    },
  },

  
  data() {
    return {
      notificacao: new Notificacao(),
      dom_publicacao: {},
      possuidor: new PessoaAutoInfracaoTransito(),
      carregado: false,
      showmanowanderley: false,
    };
  },

  watch: {},


  computed: {

    isMultaNIC() {
      return this.auto_infracao_transito.isMultaNIC()
    },

    valorDaInfracao()
    {
      return this. isMultaNIC && this.dadosAit ? this.dadosAit.valor_infracao : this.auto_infracao_transito.vigencia_codigo_infracao.valor_infracao
    },

  },

  methods: {
    temValor(valor) {
      return valor ? valor : "-";
    },

    formataReal(vlaor) {
      return helperNumeros.formatReal(vlaor);
    },

    dataBrasil(vlaor) {
      return helperDatas.dataBrasil(vlaor);
    },

    dataHoraBrasil(vlaor) {
      return helperDatas.dataHoraBrasil(vlaor);
    },

    descricaoTipoNotificacao(tipo_notificacao) {
      return tipo_notificacao.tipo_nit_nap + " - " + tipo_notificacao.descricao;
    },

    tipoPnenalidade() {
      return this.notificacao.id != null
        ? this.notificacao.lote_remessa_correio.id != null
          ? this.descricaoTipoNotificacao(
              this.notificacao.lote_remessa_correio.tipo_notificacao
            )
          : this.descricaoTipoNotificacao(
              this.notificacao.notificacao_pendente.tipo_notificacao
            )
        : "";
    },

    loadInfos() {
      if (!this.carregado) {
        this.carregado = true;
        this.showmanowanderley = true;
        this.showmanowanderleyFici = true;
        this.inicializar();
        this.$api.Multa.buscarTitularInfracaoNap({
          hash: this.auto_infracao_transito.hash,
        })
          .then(async (response) => {
            this.showmanowanderley = false;
            if (response.data.success && response.data.data) {
              this.possuidor = new PessoaAutoInfracaoTransito(
                response.data.data
              );
            }
          })
          .catch(() => {
            this.showmanowanderley = false;
          });
      }
    },

    inicializar() {
      if (this.auto_infracao_transito.notificacao.length > 0) {
        var notificacao = this.auto_infracao_transito.notificacao.find(
          (el) =>
            el.lote_remessa_correio.id != null &&
            !el.lote_remessa_correio.tipo_notificacao.isNIT()
        );
        if (notificacao == null)
          notificacao = this.auto_infracao_transito.notificacao.find(
            (el) =>
              el.notificacao_pendente.id != null &&
              !el.notificacao_pendente.tipo_notificacao.isNIT()
          );
        else if (
          notificacao.lote_remessa_correio.id != null &&
          notificacao.lote_remessa_correio.dom_publicacao_lote != null &&
          notificacao.lote_remessa_correio.dom_publicacao_lote.length > 0
        )
          this.dom_publicacao =
            notificacao.lote_remessa_correio.dom_publicacao_lote[0].dom_publicacao;

        this.notificacao = new Notificacao(notificacao);
      }
    },
  },
};
</script>

<style scoped>
.input-group-sm > .form-control {
  font-weight: 700 !important;
}
</style>